<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Paste from Excel</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()">
  </button>
</div>
<div class="modal-body">
  <form>
    <div class="form-group">
      <p>Copy and paste location information into the appropriate columns below.</p>
      <p>Download <a href="javascript:void(0)" (click)="downloadTemplate()">airport locations template</a> for
        Excel.</p>

      <!--            <hot-table-->
      <!--                [data]="dataTable"-->
      <!--                [minRows]="14"-->
      <!--                [colHeaders]="true"-->
      <!--                [rowHeaders]="true"-->
      <!--                [colWidths]="[100,130,80,80,120,120,110,110,80]"-->
      <!--                [readOnly]="loading"-->
      <!--                height="300"-->
      <!--                startRows="14"-->
      <!--                hotId="locationsSpreadsheet">-->
      <!--                <hot-column data="location" title="IATA or ICAO"></hot-column>-->
      <!--                <hot-column data="volume" title="{{tender.company.settings.getFieldName('total_volume', 'Total Volume')}}"></hot-column>-->
      <!--                <hot-column data="units" title="Units"></hot-column>-->
      <!--                <hot-column data="award_quota" title="Award Quota (%)"></hot-column>-->
      <!--                <hot-column data="delivery_to_airport" title="Delivery to airport"></hot-column>-->
      <!--                <hot-column data="delivery_to_aircraft" title="Delivery to aircraft"></hot-column>-->
      <!--                <hot-column data="date_start" title="Contract start"></hot-column>-->
      <!--                <hot-column data="date_end" title="Contract end"></hot-column>-->
      <!--                <hot-column data="currency" title="Currency"></hot-column>-->
      <!--            </hot-table>-->
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="close()">Close</button>
  <button (click)="saveTable()" [disabled]="this.loading" class="btn btn-primary">Save</button>
</div>